import React from 'react';
import { Item, ItemDefinition, registry, RenderProps } from '../Item';
import { SCROLLABLE_CONTAINER } from '../itemIds';

export interface ScrollableContainerProps {
  height?: string;
  overflow?: string;
  center?: boolean;
}

export type ScrollableContainerDefinition = ItemDefinition<
  typeof SCROLLABLE_CONTAINER,
  ScrollableContainerProps
>;

export class ScrollableContainer extends Item<
  typeof SCROLLABLE_CONTAINER,
  ScrollableContainerProps
> {
  protected render({
    height,
    overflow,
    center,
    children
  }: RenderProps<ScrollableContainerProps>) {
    // When `center` is set the content is vertically centered while still being
    // scrollable. `margin: auto` on the inner wrapper centers short content but,
    // unlike `justify-content: center`, keeps the top reachable when the content
    // is taller than the container.
    if (center) {
      return (
        <div
          style={{
            height,
            overflow,
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          <div style={{ margin: 'auto' }}>{children}</div>
        </div>
      );
    }

    return (
      <div
        style={{
          height,
          overflow
        }}
      >
        {children}
      </div>
    );
  }
}

registry[SCROLLABLE_CONTAINER] = ScrollableContainer;
